export default {
	id: "brown",
	name: "Brown",
	colors: {
		"--theme-foreground": "#DDB9B8",
		"--theme-foreground-muted": "#99807F",
		"--theme-foreground-against-accent": "#FFD6D4",
		"--theme-background": "#221D1C",
		"--theme-background-muted": "#282221",
		"--theme-border": "#887271 ",
		"--theme-border-muted": "#332B2A ",
		"--theme-menu-foreground": "#FFD6D4 ",
		"--theme-menu-background": "#161619",
		"--theme-good": "#65C05A",
		"--theme-bad": "#FF5763",
		"--theme-foreground-against-good": "#FFD6D4",
		"--theme-foreground-against-bad": "#FFD6D4",
	}
};
